import React, { useMemo } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link'],
  ['clean'],
];

/**
 * Vendor-friendly WYSIWYG editor (stores HTML under the hood).
 */
const ContractRichTextEditor = ({ value, onChange, placeholder, className = '' }) => {
  const modules = useMemo(
    () => ({
      toolbar: TOOLBAR,
      clipboard: { matchVisual: false },
    }),
    []
  );

  const formats = useMemo(
    () => ['header', 'bold', 'italic', 'underline', 'list', 'bullet', 'link'],
    []
  );

  return (
    <div className={`contract-rich-editor rounded-lg border border-gray-300 overflow-hidden bg-white ${className}`}>
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={(html) => onChange?.(html)}
        modules={modules}
        formats={formats}
        placeholder={placeholder || 'Write your contract terms…'}
      />
      <style>{`
        .contract-rich-editor .ql-toolbar.ql-snow {
          border: none;
          border-bottom: 1px solid #e5e7eb;
          background: #f9fafb;
        }
        .contract-rich-editor .ql-container.ql-snow {
          border: none;
          font-size: 0.875rem;
          min-height: 280px;
        }
        .contract-rich-editor .ql-editor {
          min-height: 280px;
        }
        .contract-rich-editor .ql-editor.ql-blank::before {
          color: #9ca3af;
          font-style: normal;
        }
      `}</style>
    </div>
  );
};

export default ContractRichTextEditor;
